module.exports = __webpack_public_path__ + "img/drag-n-drop2-blue.27aee46c.svg";